import Vue from 'vue'
import Router from 'vue-router'
import gk from '@/components/gk' // 高复
import zk from '@/components/zk2023' // 中复
import art from '@/components/art' // 艺体生
import gzgk from '@/components/gzgk' // 春季高考  高职高考
import ga from '@/components/ga' // 港澳台
import photo from '@/components/photo'
import yixuekao from '@/components/yixuekao' // 依学考
import cc from '@/components/cc' // 文化课
Vue.use(Router)

export default new Router({
  routes: [
    {
      // },
      // {
      // path: '/',
      // name: 'yixuekao',
      // component: yixuekao
      // },
      //  {
      path: '/',
      name: 'cc',
      component: cc
      // path: '/',
      // name: 'photo',
      // component: photo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js